import React, {
  ReactElement,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
  Modifier,
  RichUtils,
} from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";
import StaticToolbar, { toolbarPlugin } from "../editor/StaticToolbarEdit";
import createLinkifyPlugin, { extractLinks } from "@draft-js-plugins/linkify";
import { connect } from "react-redux";
import editorStyles from "./SimpleMentionEditor.module.css";
import mentions from "./Mentions";
import "@draft-js-plugins/mention/lib/plugin.css";
import { stateToHTML } from "draft-js-export-html";
import { useEffect } from "react";
import { getCommonData } from "../../Common";
import action from "../../Actions";
import Modal from "../UI/modal/Modal";
import { Button, Message } from "../UI";
import axios from "axios";
import ImagePreview from "../UI/ImagePreview";
import { Alert } from "react-bootstrap";

const styles = {
  link: {
    color: "blue",
    textDecoration: "underline",
  },
};
const Link = (props) => {
  const { contentState, entityKey } = props;
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <a href={url} style={styles.link}>
      {props.children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

const LinkDecorator = {
  strategy: findLinkEntities,
  component: Link,
};

let newarrayAll = [];

const ReasonNote = (props) => {
  const ref = useRef(null);

  const [state, setState] = useState({
    attachImages: {},
    editorState: EditorState.createEmpty(),
    selectedText: "",
    insertText: "",
    imageFailedError: [],
    insertUrlText: "",
    insertUrl: false,
    isSubmitting: false,
    mainImageUpload: false,
    noteerror: "",
    imageisUpload: false,
    attachments: [],
    addMention: [],
    errors: {},
    images: [],
    createBoard: {},
    attachShow: false,
  });
  const [open, setOpen] = useState(false);
  const [suggestions, setSuggestions] = useState(
    props.users &&
      Object.keys(props.users).map((item) => ({
        name: props.users[item]?.name,
        email: props.users[item]?.email,
        avatar: props.users[item]?.profile_image,
        user_uuid: item,
      }))
  );
  useEffect(() => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator

    const errors = {
      ...state.errors,
    };
    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    } else {
      errors["insertUrlText"] = "";
    }
    setState((state) => {
      return {
        ...state,
        errors,
      };
    });
  }, [state.insertUrlText]);

  const onChange = (editorState) => {
    setState((state) => {
      return {
        ...state,
        editorState,
        insertUrlText: "",
      };
    });
    const contentcheck = editorState.getCurrentContent();
    const rowContent = convertToRaw(contentcheck);
    const plainText = rowContent.blocks
      .map((block) => block.text.trim())
      .join("");
    if (plainText.length > 0) {
      setState((state) => {
        return {
          ...state,
          noteerror: "",
        };
      });
    }
    let urlText = "";
    let html = stateToHTML(state.editorState.getCurrentContent());
    const raw = convertToRaw(state.editorState.getCurrentContent());
    const { blocks } = raw;
    if (props.editNote && blocks[0].text !== "") {
      props.getRawDataOnchange(html, mention);
    }
    const currentContent = editorState.getCurrentContent();
    const currentSelection = editorState.getSelection();
    if (currentSelection.isCollapsed()) {
      setState((state) => {
        return {
          ...state,
          selectedText: "",
          insertText: "",
          insertUrlText: "",
        };
      });
      return;
    }
    const startOffset = currentSelection.getStartOffset();
    const endOffset = currentSelection.getEndOffset();
    const isBackward = currentSelection.getIsBackward();
    let selectedText;
    if (isBackward) {
      selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(currentSelection.getStartKey())
        .getText()
        .slice(
          currentSelection.getFocusOffset(),
          currentSelection.getAnchorOffset()
        );
      setState((state) => {
        return {
          ...state,
          errors: {},
        };
      });
    } else {
      selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(currentSelection.getStartKey())
        .getText()
        .slice(
          currentSelection.getAnchorOffset(),
          currentSelection.getFocusOffset()
        );
      setState((state) => {
        return {
          ...state,
          errors: {},
        };
      });
    }
    // get the url

    const start = currentSelection.getStartOffset();
    const end = currentSelection.getEndOffset();
    const contentState = editorState.getCurrentContent();
    const block = contentState.getBlockForKey(currentSelection.getStartKey());
    const entityKey = block.getEntityAt(start);
    if (entityKey) {
      const entity = contentState.getEntity(entityKey);
      if (entity.getType() === "LINK") {
        const url = entity.getData().url;
        urlText = url;
      }
    }
    setState((state) => {
      return {
        ...state,
        selectedText: selectedText,
        insertText: selectedText,
        insertUrlText: urlText || state.insertUrlText,
      };
    });
  };
  const removeNoteImages = (ind) => {
    const newimage = {
      ...delete state.attachImages[ind],
      ...state.attachImages,
    };
    setState((state) => {
      return {
        ...state,
        attachImages: newimage,
      };
    });
  };
  const { MentionSuggestions, plugins } = useMemo(() => {
    const mentionPlugin = createMentionPlugin({
      supportWhitespace: true,
      mentionPrefix: "@",
    });
    const { MentionSuggestions } = mentionPlugin;
    let linkifyPlugin = createLinkifyPlugin();
    const plugins = [
      mentionPlugin,
      StaticToolbar,
      toolbarPlugin,
      linkifyPlugin,
    ];
    return { plugins, MentionSuggestions };
  }, []);
  const onOpenChange = useCallback((open) => {
    setOpen(open);
  }, []);
  const onSearchChange = useCallback(
    ({ value }) => {
      setSuggestions(
        defaultSuggestionsFilter(
          value,
          Object.keys(props.users).map((item) => ({
            name: props.users[item]?.name,
            email: props.users[item]?.email,
            avatar: props.users[item]?.profile_image,
            user_uuid: item,
          }))
        )
      );
    },
    [props.users]
  );
  const getBlobImages = (images, ind) => {
    const blob = images?.file_url;
    const ext = images?.file_name?.split(".").pop();
    const allow_images = ["jpg", "png", "jpeg"];

    return (
      <div class="img-box">
        {allow_images.includes(ext) ? (
          <img
            src={blob}
            class="img-fluid"
            style={{ width: "130px", height: "55px" }}
            // onClick={() => this.previewImage(blob)}
          />
        ) : (
          <i className="fa fa-file" style={{ fontSize: "40px" }}></i>
        )}

        <figure>
          {images?.file_name?.slice(0, 6) +
            "..." +
            images?.file_name?.slice(images?.file_name.length - 1, 6) +
            "." +
            ext}
        </figure>
        <div class="delete" onClick={() => removeNoteImages(ind)}>
          <svg
            width="11"
            height="10"
            viewBox="0 0 11 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Remove</title>
            <path
              d="M8.21973 2.5L3.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M3.21973 2.5L8.21973 7.5"
              stroke="#737373"
              stroke-width="1.33"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
        </div>
      </div>
    );
  };
  const handleOnChange = (editorState) =>
    setState((state) => {
      return { ...state, editorState };
    });

  const handleBeforeInput = (chars, editorState) => {
    const currentContentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();

    handleOnChange(
      EditorState.push(
        editorState,
        Modifier.replaceText(currentContentState, selectionState, "")
      )
    );

    return;
  };
  const uploadImagesMultiple = (images) => {
    setState((state) => {
      return {
        ...state,
        imageisUpload: true,
      };
    });
    const data = getCommonData();
    const allPromise = images.map((file) => {
      let formdata = new FormData();
      formdata.append("app_token", data.app_token);
      formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
      formdata.append(`image`, file);
      return new Promise((resolve, reject) => {
        axios
          .post(`${data.apiUrl}attachment/upload`, formdata, {
            headers: {
              "Content-Type": "multipart/formdata",
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((error) => {
            setTimeout(() => {
              setState((state) => {
                return {
                  ...state,
                  imageisUpload: false,
                  createBoard: {
                    ...state.createBoard,
                    board: true,
                    bg: "danger",
                    title: "error",
                    position: "bottom-end",
                    message: error.message,
                  },
                };
              });
            });
          });
      });
    });
    const request = Promise.allSettled(allPromise);
    return request;
  };

  const newPromiseUploader = (formdata) => {
    let newarr = [];
    const data = getCommonData();
    return new Promise((resolve, reject) => {
      axios
        .post(`${data.apiUrl}attachment/upload`, formdata, {
          headers: {
            "Content-Type": "multipart/formdata",
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            resolve(resp);
          } else {
            reject(resp);
          }
        })
        .catch((error) => {
          const arrnewcon = [...newarrayAll];
          if (arrnewcon.length > 0) {
            let newfile = arrnewcon.find((item) => {
              return (
                item.name.toLowerCase() ===
                formdata.get("image").name.toLowerCase()
              );
            });
            if (!newfile) {
              getStoreData({
                name: formdata.get("image").name,
                message: error.message,
              });
            }
          } else {
            getStoreData({
              name: formdata.get("image").name,
              message: error.message,
            });
          }
          reject(error);
        });
    });
  };

  const removeImageHandler = (index, name) => {
    const attachments = [...state.attachments];
    attachments.splice(index, 1);
    const alertError = [...newarrayAll];
    const indexr = alertError.findIndex((item) => item.name === name);
    alertError.splice(indexr, 1);
    newarrayAll = alertError;
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };

  const getStoreData = (obj) => {
    const failedImagesIssue = [...newarrayAll];
    failedImagesIssue.push(obj);
    newarrayAll = failedImagesIssue;
  };

  const onSubmitAttachmentHandler = async (evt) => {
    evt.preventDefault();
    if (state.attachments.length > 0) {
      setState((state) => {
        return {
          ...state,
          mainImageUpload: true,
        };
      });
      const data = getCommonData();
      let newarray = [];
      const appPromis = state.attachments.map((file) => {
        let formdata = new FormData();
        formdata.append("app_token", data.app_token);
        formdata.append("product_key", process.env.REACT_APP_PRODUCT_KEY);
        formdata.append(`image`, file);
        const result = newPromiseUploader(formdata);
        result.then((resp) => {
          if (resp.data.code === 400 || resp.data.code === 1208) {
            const arrnewcon = [...newarrayAll];
            if (arrnewcon.length > 0) {
              let newfile = arrnewcon.find((item) => {
                return item.name.toLowerCase() === file.name.toLowerCase();
              });
              if (!newfile) {
                getStoreData({
                  name: file.name,
                  message: resp.data.message,
                });
              }
              // return;
            } else {
              getStoreData({
                name: file.name,
                message: resp.data.message,
              });
            }
          }
        });
        return result;
      });

      const request = await Promise.allSettled(appPromis);
      if (request.length > 0) {
        let newfilearray = {};
        request.forEach((it) => {
          if (it.status === "fulfilled") {
            const {
              data: { data },
            } = it.value;
            newfilearray = { ...newfilearray, ...data };
          } else {
          }
        });

        if (
          newfilearray &&
          request.every(
            (item) =>
              item.status === "fulfilled" && item.value.data.code === 200
          )
        ) {
          setTimeout(() => {
            setState((state) => {
              return {
                ...state,
                attachments: [],
                attachImages: newfilearray,
                attachShow: false,
                mainImageUpload: false,
              };
            });
          }, 200);

          // this.props.saveAttachment({ attachments: newfilearray });
          // this.props.updateAttachment({
          //   attachment: newfilearray,
          //   app_token: this.state.boarddata.app_token,
          //   attribute_set_key: this.props.match.params.attribute_set_key,
          //   customer_tattle_uuid: +this.props.match.params.id,
          // });
        } else {
          setState((state) => {
            return { ...state, attachShow: true, mainImageUpload: false };
          });
        }
      }
    }
  };
  const attachmentUploadHandler = (evt) => {
    const files = evt.target.files;
    const attachments = [...state.attachments];
    for (let i = 0; i < files.length; i++) {
      attachments.push(files[i]);
    }
    setState((state) => {
      return {
        ...state,
        attachments,
      };
    });
  };

  const hideUiModal = () => {
    setState((state) => {
      return {
        ...state,
        attachShow: false,
      };
    });
  };

  const getModalContent = () => {
    return (
      <>
        <form onSubmit={onSubmitAttachmentHandler}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="file-select">
                <div className="file-select-name" id="noFile2">
                  <div>
                    <svg
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.4966 2.21875C10.6066 2.25362 7.84482 3.41715 5.80115 5.46082C3.75748 7.50449 2.59395 10.2663 2.55908 13.1562C2.59395 16.0462 3.75748 18.808 5.80115 20.8517C7.84482 22.8953 10.6066 24.0589 13.4966 24.0938C16.3866 24.0589 19.1483 22.8953 21.192 20.8517C23.2357 18.808 24.3992 16.0462 24.4341 13.1562C24.3992 10.2663 23.2357 7.50449 21.192 5.46082C19.1483 3.41715 16.3866 2.25362 13.4966 2.21875ZM19.7466 13.9375H14.2778V19.4062H12.7153V13.9375H7.24658V12.375H12.7153V6.90625H14.2778V12.375H19.7466V13.9375Z"
                        fill="#717171"
                      ></path>
                    </svg>
                  </div>
                  Add File
                </div>
                <input
                  type="file"
                  name="chooseFile"
                  id=""
                  title=""
                  multiple
                  onChange={attachmentUploadHandler}
                />
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="custom_image">
                <div className="afterupload-image">
                  {state.attachments.map((file, index) => {
                    const imgg = URL.createObjectURL(file);
                    return (
                      <div class="img-box">
                        <ImagePreview
                          headImage={imgg}
                          ext={file.name.split(".").pop()}
                          imgLength={state.attachments}
                          width="128px"
                          height="58px"
                        />

                        <figure>
                          {file?.name?.slice(0, 6) +
                            "." +
                            file?.name.split(".").pop()}
                        </figure>
                        <div
                          class="delete"
                          onClick={() => removeImageHandler(index, file.name)}
                        >
                          <svg
                            width="11"
                            height="10"
                            viewBox="0 0 11 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <title>Remove</title>
                            <path
                              d="M8.21973 2.5L3.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            <path
                              d="M3.21973 2.5L8.21973 7.5"
                              stroke="#737373"
                              stroke-width="1.33"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {newarrayAll.length > 0 && (
                  <div className="image_failed_list">
                    {" "}
                    <ul>
                      {newarrayAll.map((item, index) => (
                        <li>
                          <Alert variant="danger">
                            {item.name} : {item.message}
                          </Alert>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="cancl-cls"
              data-bs-dismiss="modal"
              onClick={hideUiModal}
            >
              Cancel
            </button>
            <button type="submit" className="submit-cls">
              {state.mainImageUpload ? "Uploading..." : "Submit"}
            </button>
          </div>
        </form>
      </>
    );
  };

  const getImageHandler = async (images) => {
    newarrayAll = [];
    setState((state) => {
      return {
        ...state,
        attachShow: true,
        attachments: [],
      };
    });
    // alert();
    // if (images.length > 0) {
    //   let results = await uploadImagesMultiple(images);
    //   if (results.length > 0) {
    //     setState((state) => {
    //       return {
    //         ...state,
    //         imageisUpload: false,
    //       };
    //     });
    //     let newfilearray = {};
    //     results.forEach((it) => {
    //       if (
    //         it.status === "fulfilled" &&
    //         results.some((item) => item.value.data.code === 200)
    //       ) {
    //         const {
    //           data: { data },
    //         } = it.value;
    //         newfilearray = { ...newfilearray, ...data };
    //       }
    //     });
    //     setState((state) => {
    //       return {
    //         ...state,
    //         attachImages: { ...state.attachImages, ...newfilearray },
    //       };
    //     });
    //   }
    // }
  };

  const onHideText = () => {
    setState((state) => {
      return {
        ...state,
        insertUrl: false,
        insertText: "",
        insertUrlText: "",
        selectedText: "",
        errors: {},
      };
    });
  };

  const onUrlInsert = () => {
    setState((state) => {
      return {
        ...state,
        insertUrl: true,
      };
    });
  };

  const insertLinkHandler = (event) => {
    setState((state) => {
      return {
        ...state,
        [event.target.name]: event.target.value,
      };
    });
    validate(event);
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const pastedValue = event.clipboardData.getData("text");
    setState((state) => {
      return {
        ...state,
        [event.target.name]: pastedValue,
      };
    });
    validate(event);
  };
  // useEffect(() => {
  //   setState((state) => {
  //     return {
  //       ...state,
  //       attachImages: props.uploadAtt,
  //     };
  //   });
  // }, [props.uploadAtt]);
  const addHttp = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "http://" + url;
    }
    return url;
  };
  const validate = (evt) => {
    let errors = {};

    if (!state.insertText.trim()) {
      errors["insertText"] = "Please enter URL text";
    } else {
      errors["insertText"] = "";
    }

    if (!state.insertUrlText.trim()) {
      //url validation
      errors["insertUrlText"] = "Please enter URL";
    } else {
      errors["insertUrlText"] = "";
    }
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator

    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    }

    if (errors.insertText || errors.insertUrlText) {
      setState((state) => {
        return {
          ...state,
          errors: { ...state.errors, ...errors },
        };
      });

      return false;
    }
    setState((state) => {
      return {
        ...state,
        errors: { ...state.errors, ...errors },
      };
    });

    return true;
  };

  const insertUrlLink = () => {
    if (validate()) {
      setState((state) => {
        return {
          ...state,
          insertUrl: false,
        };
      });

      const url = addHttp(state.insertUrlText);
      const contentState = state.editorState.getCurrentContent();
      const selection = state.editorState.getSelection();
      const entityKey = contentState
        .createEntity("LINK", "MUTABLE", { url })
        .getLastCreatedEntityKey();
      const block = contentState.getBlockForKey(selection.getStartKey());
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const blockText = block.getText().slice(start, end);

      const contentWithLink = Modifier.replaceText(
        contentState,
        selection,
        state.selectedText || state.insertText || blockText,
        null,
        entityKey
      );

      const newEditorState = EditorState.push(
        state.editorState,
        contentWithLink,
        "insert-characters"
      );

      const ddeTe = EditorState.forceSelection(
        newEditorState,
        contentWithLink.getSelectionAfter()
      );
      setState((state) => {
        return {
          ...state,
          editorState: ddeTe,
          insertText: "",
          insertUrlText: "",
          errors: {},
        };
      });
    }
  };

  const onAddMention = (mention) => {
    // get the mention object selected
    const mentiosn = [...(state.addMention || [])];
    mentiosn.push(mention);
    setState((state) => {
      return {
        ...state,
        addMention: mentiosn,
      };
    });
  };

  const onClick = () => {
    const contentState = state.editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    const plainText = rawContentState.blocks
      .map((block) => block.text.trim())
      .join("");

    if (!plainText) {
      setState((state) => {
        return {
          ...state,
          noteerror: "Note shouldn't be blank",
        };
      });

      return false;
    } else {
      let html = stateToHTML(state.editorState.getCurrentContent());
      const raw = convertToRaw(state.editorState.getCurrentContent());
      const draft_js_content = JSON.stringify(raw);

      const mentions_data = [];
      const { blocks, entityMap } = raw;
      Object.values(entityMap).map((entity) => {
        if (entity.data.mention !== undefined) {
          mentions_data.push(entity.data.mention);
        }
      });
      if (mentions_data !== null && mentions_data.length > 0) {
        mentions_data.forEach((item) => {
          const replace_data = `@${item.name}`;
          if (props.users[item.user_uuid].profile_url) {
            html = html.replaceAll(
              replace_data,
              `<a target='_blank' href="${
                props.users[item.user_uuid]?.profile_url
              }">@${item.name}</a>`
            );
          } else {
            html = html.replaceAll(
              replace_data,
              `<a target='_blank' href="/user/${item.user_uuid}">@${item.name}</a>`
            );
          }
        });
      }
      const linkifys = extractLinks(html);
      const parser = new DOMParser();
      if (linkifys != null && linkifys.length > 0) {
        const doc = parser.parseFromString(html, "text/html");
        const aTags = doc.getElementsByTagName("a");

        for (let i = 0; i < aTags.length; i++) {
          const aTag = aTags[i];
          const href = aTag.getAttribute("href");
          const text = aTag.innerText;
          const linkTag = doc.createElement("a");
          linkTag.setAttribute("href", href);
          linkTag.setAttribute("target", "_blank");
          linkTag.textContent = text;
          aTag.replaceWith(linkTag);
        }
        html = doc.body.innerHTML;
      }
      const doc = parser.parseFromString(html, "text/html");
      const brTags = doc.querySelectorAll("br");
      brTags.forEach((ele) => ele.remove());

      html = doc.body.innerHTML;
      // html = html.replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, "");
      props.getRawData(
        draft_js_content,
        html,
        state.addMention,
        state.attachImages
      );
      //props.clearAllAttachment();
      let editState = EditorState.push(
        state.editorState,
        ContentState.createFromText("")
      );

      setState((state) => {
        return {
          ...state,
          editorState: editState,
          noteerror: "",
          images: [],
          addMention: [],
          attachImages: {},
        };
      });
    }
  };

  useEffect(() => {
    setSuggestions(
      Object.keys(props.users).map((item) => ({
        name: props.users[item]?.name,
        email: props.users[item]?.email,
        avatar: props.users[item]?.profile_image,
        user_uuid: item,
      }))
    );
  }, [props.users]);
  return (
    <>
      {/* <Message board={state.createBoard} /> */}
      <Modal
        show={state.attachShow}
        className="tattle-Uppopup"
        close={hideUiModal}
      >
        {getModalContent()}
      </Modal>
      <Modal show={state.insertUrl} close={onHideText}>
        <div className="form-group">
          {!state.selectedText && (
            <>
              <label className="m-0">Text</label>
              <input
                type="text"
                className="form-control"
                onChange={insertLinkHandler}
                value={state.insertText}
                name="insertText"
                placeholder="Link text"
              />
            </>
          )}
          <div className="error">
            {state.errors?.["insertText"] && state.errors?.["insertText"]}
          </div>
        </div>
        <div className="form-group">
          <label>URL</label>
          <input
            type="text"
            className="form-control"
            onChange={insertLinkHandler}
            name="insertUrlText"
            value={state.insertUrlText}
            placeholder="http://"
            onPaste={handlePaste}
          />
          <div className="error">
            {state.errors?.["insertUrlText"] && state.errors?.["insertUrlText"]}
          </div>
        </div>
        <button
          className="muBtn _blue mt-3 float-end"
          type="button"
          onClick={insertUrlLink}
        >
          OK
        </button>
      </Modal>{" "}
      <div className="error" style={{ display: "block" }}>
        {state.noteerror}
      </div>
      <div
        className={editorStyles.editor}
        onClick={() => {
          ref.current.focus();
        }}
      >
        <Editor
          editorKey={"editor"}
          editorState={state.editorState}
          onChange={onChange}
          decorators={[LinkDecorator]}
          plugins={plugins}
          handleBeforeInput={handleBeforeInput}
          placeholder={"Type to add your note..."}
          ref={ref}
        />
        <MentionSuggestions
          open={open}
          onOpenChange={onOpenChange}
          suggestions={suggestions}
          onSearchChange={onSearchChange}
          onAddMention={onAddMention}
        />
      </div>
      <div className="allTools mb-0">
        <div className="check-toolbar">
          {!props.toolbar && (
            <StaticToolbar
              getImages={getImageHandler}
              fileFalse={true}
              toggleLink={onUrlInsert}
            />
          )}{" "}
          {!props.button && props.addnote && (
            <button
              className="muBtn _blue float-end"
              onClick={onClick}
              disabled={
                props.isAdding || props.isUploadDone || state.imageisUpload
              }
            >
              {props.isAdding
                ? "Submiting..."
                : state.imageisUpload
                ? "Uploading..."
                : "Add Note"}{" "}
            </button>
          )}
        </div>
        {state.attachImages && Object.keys(state.attachImages).length > 0 && (
          <div className="custom_image">
            <div class="afterupload-image mt-2">
              {state.attachImages &&
                Object.keys(state.attachImages).map((item, ii) => {
                  return getBlobImages(state.attachImages[item], item);
                })}
            </div>
          </div>
        )}
      </div>{" "}
      {props.button && (
        <Button
          className="muBtn _blue mt-3"
          onClick={onClick}
          isDisabled={props.buttonDisabled}
          isAdding={props.isAdding}
        >
          {props.isAdding
            ? "Submitting..."
            : `${props.buttonText || "Add Note"}`}
        </Button>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    uploadAtt: state.boardAttribute.allAttachImage_add?.["note"],
    isUploadDone: state.boardAttribute?.isImageUpload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    uploadImage: (inputs) => {
      return dispatch(action.UploadImage(inputs));
    },
    clearAllAttachment: () => {
      return dispatch(action.clearAllAttachment());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReasonNote);
